var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50599 16.4174L8.80999 3.91309C9.73779 4.45929 14.4162 7.04847 15.1718 7.54081L7.86779 20.0459C7.06896 21.1012 0.493992 18.0189 1.50599 16.4167V16.4174Z",
    fill: "#FBBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4913 16.4173L15.1873 3.91376C14.1662 2.21444 11.967 1.59693 10.1607 2.60058C8.3544 3.60424 7.8044 5.76631 8.82551 7.54148L16.1295 20.0466C17.1506 21.7451 19.3499 22.3627 21.1561 21.359C22.8835 20.3553 23.5124 18.1167 22.4913 16.4189V16.4173Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66641 21.8422C6.69132 21.8422 8.33283 20.2414 8.33283 18.2668C8.33283 16.2922 6.69132 14.6914 4.66641 14.6914C2.64151 14.6914 1 16.2922 1 18.2668C1 20.2414 2.64151 21.8422 4.66641 21.8422Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/googleAds.f1b4649e61d7484bd02d0950a2948e4c.svg";
export { ForwardRef as ReactComponent };